import { faFile } from '@fortawesome/pro-light-svg-icons'

import { TopBar } from '@domain-group/suit-theme'

import useDashboardSearch from './hooks/useDashboardSearch'
import SearchResult from './components/SearchResult'

interface DashboardSearchProps {
  searchEntities: Array<any>,
}

const DashboardSearch = (props:DashboardSearchProps) => {
  const { searchEntities } = props

  const {
    callbacks: {
      dashboardSearch,
      mapResults,
    },
  } = useDashboardSearch({ searchEntities })

  return (
    <TopBar.Search
      // @ts-expect-error TS2322
      callbacks={{ search: dashboardSearch }}
      // @ts-expect-error TS2345
      mapResults={data => mapResults(data)}
      // @ts-expect-error TS2339
      renderResult={entity => <SearchResult key={entity.id} icon={faFile} result={entity} />}
    />
  )
}

export default DashboardSearch
